import { FilterChipTypeEnum } from './filter-chip-type.enum';

export class FilterChipBaseModel<T, RT = T> {
  public id: number = this._consData.id;
  public title: string = this._consData.title;
  public icon: string = this._consData.icon;
  public disabled: boolean = this._consData.disabled;
  public active: boolean = this._consData.active;
  public type: FilterChipTypeEnum = this._consData.type;
  public filterFn: (originalList: T) => RT = this._consData.filterFn;

  constructor(private _consData: Omit<FilterChipBaseModel<T, RT>, '_consData'>) {}
}
